import { Link, useLocation } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";
import { NavDropdownContent } from "./NavDropdownContent";
import {
  ADMIN_DIRECT_LINKS,
  ADMIN_NAV_GROUPS,
  INSTALLER_DIRECT_LINKS,
  INSTALLER_NAV_GROUPS,
  isPathActive,
  isGroupActive,
} from "./nav-config";

interface DesktopNavProps {
  role: "admin" | "installer";
}

export function DesktopNav({ role }: DesktopNavProps) {
  const location = useLocation();
  const currentPath = location.pathname;

  // Valitse oikeat linkit roolin mukaan
  const directLinks =
    role === "admin" ? ADMIN_DIRECT_LINKS : INSTALLER_DIRECT_LINKS;
  const navGroups =
    role === "admin" ? ADMIN_NAV_GROUPS : INSTALLER_NAV_GROUPS;

  return (
    <nav className="hidden md:flex items-center gap-1">
      {/* Suorat linkit */}
      {directLinks.map((link) => {
        const isActive = isPathActive(currentPath, link.to);

        return (
          <Button
            key={link.to}
            variant="ghost"
            asChild
            className={cn(
              "gap-2",
              isActive && "bg-accent text-accent-foreground"
            )}
          >
            <Link to={link.to}>
              <link.icon className="h-4 w-4" />
              {link.label}
            </Link>
          </Button>
        );
      })}

      {/* Dropdown-ryhmät */}
      {navGroups.map((group) => {
        const groupIsActive = isGroupActive(currentPath, group);

        return (
          <DropdownMenu key={group.id}>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                className={cn(
                  "gap-2",
                  groupIsActive && "bg-accent text-accent-foreground"
                )}
              >
                <group.icon className="h-4 w-4" />
                {group.label}
                <ChevronDown className="h-3 w-3" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-[280px] p-2">
              <NavDropdownContent
                links={group.links}
                currentPath={currentPath}
              />
            </DropdownMenuContent>
          </DropdownMenu>
        );
      })}
    </nav>
  );
}
